import { Component, Input } from '@angular/core';
import { InstallierteLeistungAggregate } from '../../../domain/model/report/installierte-leistung-aggregate';
import { Leistungseinheit } from '../../../domain/model/leistungseinheit';

@Component({
    selector: 'tnb-aggregated-installierte-leistung-by-anlagentyp',
    templateUrl: './aggregated-installierte-leistung-by-anlagentyp.component.html',
    styleUrls: [
        './aggregated-installierte-leistung-by-anlagentyp.component.scss',
    ],
    standalone: false,
})
export class AggregatedInstallierteLeistungByAnlagentypComponent {

    @Input()
    public aggregations: InstallierteLeistungAggregate[] = [];

    @Input()
    public leistungseinheit?: Leistungseinheit = null;

    constructor() {
    }

}
